<template>
    <div 
        v-if="reference_map[table_id]"
        id="map-display-switch"
        class="switch"
    >
        <span class="switch__text">監控地圖</span>
        <v-switch
            v-model="is_monitor_open_emap"
        />
    </div>
</template>

<script>
    import { fire_resize } from '@/utils/emap/lib.js'
    import { 
        TABLE_VALUE_TEXT_MAPPING,
    } from "@/config/monitor_config.js"
    import { reconstruct_alert_content } from '@/utils/monitor/monitor.js'
    import { mapState, mapMutations, mapGetters } from 'vuex'
    export default {
        name: 'MapDisplaySwitch',

        props: {
            table_id: {
                type: Number,
                require: true,
                default: -1,
            },

            table_data: {
                type: Array,
                default: () => []
            }
        },

        computed: {
            ...mapState('monitor', [
                'is_monitor',
                'reference_map',
            ]),
            ...mapGetters(['is_mobile_width', 'is_pad_width']),

            is_monitor_open_emap: {
                get() {
                    return this.$store.state['emap-monitor'].is_monitor_open_emap
                },

                set(boolean_value) {
                    const new_monitor_alert = boolean_value 
                        ? this.make_monitor_alert() 
                        : {
                            alert_content: {},
                            file_path: '',
                        }
                    this.set_monitor_alert(new_monitor_alert)

                    if (boolean_value) {
                        fire_resize();
                        this.set_selected_products([]);
                    } else {
                        this.set_focal_sign_number('');
                    }
                    
                    /* 
                        都處理好其他工作再執行
                        前面的 vuex 操作會與 is_monitor_open_emap 的狀態有關
                    */
                    this.set_is_monitor_open_emap(boolean_value)
                }
            },

            tag_name() {
                return `${TABLE_VALUE_TEXT_MAPPING[this.default_value]['tag_name']}`
            },
        },

        watch: {
            is_monitor() {
                this.is_monitor_open_emap = false;
            },

            is_monitor_open_emap() {
                if (this.is_mobile_width || this.is_pad_width) return;
                const map_btn_menu_dom = document.querySelectorAll('.map-btn-menu');
                const main_menu_dom = document.querySelector('.main-menu__container');
                const main_block_options_dom = document.querySelector('.main-block-options__background');
                const right_width = main_menu_dom.clientWidth + main_block_options_dom.clientWidth + 70;
                map_btn_menu_dom.forEach(item => {
                    item.style.position = 'fixed';
                    item.style.right = right_width + 'px';
                });
            }
        },

        beforeDestroy() {
            this.is_monitor_open_emap = false;
        },

        methods: {
            ...mapMutations('emap-monitor', [
                'set_is_monitor_open_emap',
                'set_monitor_alert',
                'set_focal_sign_number'
            ]),

            ...mapMutations('emap', [
                'set_selected_products',
            ]),

            make_monitor_alert() {
                return {
                    alert_content: reconstruct_alert_content(this.table_data),
                    file_path: this.reference_map[this.table_id],
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .switch {
        display: flex;
        align-items: center;
        gap: 1rem;
        margin-left: 1rem;
    }
</style>